import ApiService from './ApiService'
import appConfig from '../configs/app.config'

/**
 * =====================================================
 * AUTH SERVICE
 * Kimlik doğrulama ve şifre yönetimi için API servisleri
 * =====================================================
 */

// =====================================================
// WEB LOGIN - Kullanıcı girişi
// =====================================================
/*
REQUEST:
  Method: POST
  URL: {{url}}/weblogin
  Body:
{
    "email": "test.kullanici1",
    "password": "135",
    "new_password": "456" // opsiyonel - şifre yenileme durumunda
}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9..." // JWT Token
}

RESPONSE (Password Renewal Required):
{
    "Status": "Normal",
    "Content": {
        "user_must_renew_password": true,
        "regex": {
            "pattern": "^\\d{3}$",
            "description": "Sadece 3 basamaklı rakamlardan oluşan bir şifre. Örn: 123"
        },
        "number_of_last_n_passwords": 0
    }
}

RESPONSE (Error):
{
    "Status": "Error",
    "Content": "Invalid credentials"
}
*/
export async function apiSignIn (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'weblogin',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// =====================================================
// PASSWORD REGEX - Şifre regex bilgilerini al
// =====================================================
/*
REQUEST:
  Method: GET
  URL: {{url}}/passwordregex
  Headers:
    - project_id: {{project_id}}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": {
        "pattern": "^\\d{3}$",
        "description": "Sadece 3 basamaklı rakamlardan oluşan bir şifre. Örn: 123"
    }
}
*/
export async function apiGetPasswordRegex () {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'passwordregex',
        method: 'get',
        headers: {'Content-Type' : 'application/json'}
    })
}

// =====================================================
// WEB REFRESH TOKEN - Token yenileme
// =====================================================
/*
REQUEST:
  Method: POST
  URL: {{url}}/webrefreshtoken
  Body:
{
    "token": "existing_jwt_token"
}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": "new_jwt_token..."
}
*/
export async function apiCheckAuth (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'webrefreshtoken',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function apiSignUp (data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut (data) {
	localStorage.removeItem('project_id');
	localStorage.removeItem('project_name');
    /*
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
    */
}

// =====================================================
// FORGET PASSWORD - Şifremi unuttum
// =====================================================
/*
REQUEST:
  Method: POST
  URL: {{url}}/forgetpassword
  Headers:
    - token: {{token}} (opsiyonel)
    - project_id: {{project_id}} (opsiyonel)
  Body:
{
    "e_mail": "volkan.ucak"
    // "reset_type": "sms"     // opsiyonel - sms ile sıfırlama
    // "reset_type": "e_mail"  // opsiyonel - e-posta ile sıfırlama
}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": "Password reset code sent"
}

RESPONSE (Error):
{
    "Status": "Error",
    "Content": "User not found"
}
*/
export async function apiForgotPassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'forgetpassword',
        method: 'post',
        data
    })
}

// =====================================================
// CONFIRM PASSWORD - Doğrulama kodu ile şifre sıfırlama
// =====================================================
/*
REQUEST:
  Method: POST
  URL: {{url}}/confirmpassword
  Headers:
    - token: {{token}} (opsiyonel)
    - project_id: {{project_id}} (opsiyonel)
  Body:
{
    "reset_type": "sms",           // veya "e_mail"
    "e_mail": "volkan.ucak",
    "confirmation_code": "095316",
    "new_password": "135"
}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": "Password changed successfully"
}

RESPONSE (Error):
{
    "Status": "Error",
    "Content": "Invalid confirmation code"
}
*/
export async function apiVerifyCodeAndChangePassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'confirmpassword',
        method: 'post',
        data
    })
}


// =====================================================
// CHANGE PASSWORD - Giriş yapmış kullanıcı için şifre değiştirme
// =====================================================
/*
REQUEST:
  Method: POST
  URL: {{url}}/changepassword
  Headers:
    - token: {{token}}
    - project_id: {{project_id}}
  Body:
{
    "current_password": "987",
    "new_password": "135"
}

RESPONSE (Success):
{
    "Status": "Normal",
    "Content": "Password changed successfully"
}

RESPONSE (Error):
{
    "Status": "Error",
    "Content": "Current password is incorrect"
}
*/
export async function apiChangePassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'changepassword',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// =====================================================
// RESET PASSWORD - Şifre sıfırlama (legacy)
// =====================================================
/*
REQUEST:
  Method: POST
  URL: /reset-password
  Body:
{
    "email": "user@example.com",
    "token": "reset_token",
    "password": "new_password"
}
*/
export async function apiResetPassword (data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}
